import { render, staticRenderFns } from "./groupInfo.vue?vue&type=template&id=4df9442b&"
import script from "./groupInfo.vue?vue&type=script&lang=js&"
export * from "./groupInfo.vue?vue&type=script&lang=js&"
import style0 from "./groupInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports